import Route from '@ember/routing/route';

export default class LibraryFoldersUploadRoute extends Route {}
